import React from "react"
import { FaReact, FaNodeJs, FaDatabase, FaFlask } from "react-icons/fa"
export default [
  {
    id: 1,
    icon: <FaReact className="service-icon" />,
    title: "React",
    text: `React has been the go-to technology for front-end in my last projects. I've got experience using React Hooks and Redux, as well as the Gatsby framework`,
  },
  {
    id: 2,
    icon: <FaNodeJs className="service-icon" />,
    title: "Node.js",
    text: `I'm a JavaScript enthusiast, so Node.js is my favorite when it comes to building RESTful web APIs. Express.js is the framework that lets me keep it clean and simple`,
  },
  {
    id: 3,
    icon: <FaDatabase className="service-icon" />,
    title: "Databases",
    text: `I've got experience developing web applications with SQL and NoSQL database management systems such as MySQL and MongoDB`,
  },
  {
    id: 4,
    icon: <FaFlask className="service-icon" />,
    title: "Testing",
    text: `I like to use Enzyme and Mocha for unit testing and Cypress for end-to-end testing`,
  },
]
